import { Component, ViewChild, ApplicationRef } from '@angular/core';
import { Platform, NavController, App }         from 'ionic-angular';
import { LoadingController }                    from 'ionic-angular';
import { StatusBar }                            from '@ionic-native/status-bar';
import { SplashScreen }                         from '@ionic-native/splash-screen';
import { LoadingPage, dmLoading }               from '../pages/loading/loading';
import { SignInPage }                           from '../pages/sign-in/sign-in';
import { WelcomePage }                          from '../pages/welcome/welcome';
import { TemplatePage }                         from '../pages/template/template';
import { HousekeepingPage }                     from '../pages/housekeeping/housekeeping';
import { DetailsPage }                          from '../pages/details/details';
import { EnablePage }                           from '../pages/enable/enable';
import { DiscountsPage }                        from '../pages/discounts/discounts';
import { DiscountCalPage }                      from '../pages/discount-cal/discount-cal';
import { RoomTypesPage }                        from '../pages/roomtypes/roomtypes';
import { AvailabilityPage }                     from '../pages/availability/availability';
import { OfferTypesPage }                       from '../pages/offertypes/offertypes';
import { CustomPackagesPage }                   from '../pages/custom-packages/custom-packages';
import { EarlyBirdPage }                        from '../pages/earlybird/earlybird';
import { ChannelPage }                          from '../pages/channel/channel';
import { RatesPage }                            from '../pages/rates/rates';
import { RoomsPage }                            from '../pages/rooms/rooms';
import { TaskListPage }                         from '../pages/task-list/task-list';
import { TaskReportPage }                       from '../pages/task-report/task-report';
import { StaffPage }                            from '../pages/staff/staff';
import { DescriptionsPage }                     from '../pages/descriptions/descriptions';
import { PhotosPage }                           from '../pages/photos/photos';
import { DocsPage }                             from '../pages/docs/docs';
import { MapsPage }                             from '../pages/maps/maps';
import { FacilitiesPage }                       from '../pages/facilities/facilities';
import { CancellationPage }                     from '../pages/cancellation/cancellation';
import { BookingsPage }                         from '../pages/bookings/bookings';
import { ChangePasswordPage }                   from '../pages/change-password/change-password';
import { PaymentPage }                          from '../pages/payment/payment';
import { SpotlightPage }                        from '../pages/spotlight/spotlight';
import { PMSPage }                              from '../pages/pms/pms';;
import { dmHotel }                              from '../pages/sign-in/xv-hotel';
import { UnhandledExceptionHandler }            from '../services/UnhandledExceptions';
import { MLText }                               from '../services/MLText';
import { AppDataBroker }                        from '../services/AppData';
import { AppMenuViewModel }                     from './xv-menu';
import { RQApp }                                from '../RQuery/RQuery';
import { URLSearchParams }                      from '@angular/http';
import { DomSanitizer, SafeUrl }                from '@angular/platform-browser';


declare const console;

@Component({
    templateUrl: 'app.html'
})
export class MyApp {
    @ViewChild('rootNavController') nav: NavController;

    public console = console;

    NewLoading:         (pMessage: string) => dmLoading;
    BackToSignIn:       ()                 => void;
    GoToWelcome:        ()                 => void;
    GoToTemplate:       ()                 => void;
    GoToHousekeeping:   ()                 => void;
    GoToDetails:        ()                 => void;
    GoToEnable:         ()                 => void;
    GoToDiscounts:      ()                 => void;
    GoToDiscountCal:    ()                 => void;
    GoToRoomTypes:      ()                 => void;
    GoToAvailability:   ()                 => void;
    GoToOfferTypes:     ()                 => void;
    GoToCustomPackages: ()                 => void;
    GoToEarlyBird:      ()                 => void;
    GoToChannel:        ()                 => void;
    GoToRates:          ()                 => void;
    GoToRooms:          ()                 => void;
    GoToTaskList:       ()                 => void;
    GoToTaskReport:     ()                 => void;
    GoToStaff:          ()                 => void;
    GoToDescriptions:   ()                 => void;
    GoToPhotos:         ()                 => void;
    GoToDocs:           ()                 => void;
    GoToMaps:           ()                 => void;
    GoToFacilities:     ()                 => void;
    GoToBookings:       ()                 => void;
    GoToCancellation:   ()                 => void;
    GoToChangePassword: ()                 => void;
    GoToPayment:        ()                 => void;
    GoToSpotlight:      ()                 => void;
    GoToPMS:            ()                 => void;

    MarkURISafe:        (pURI: string)     => SafeUrl;

    rootPage: any;

    AppMenu: AppMenuViewModel;

    constructor(
         platform:       Platform
        ,statusBar:      StatusBar
        ,splashScreen:   SplashScreen
        ,applicationRef: ApplicationRef
        ,application:    App
        ,exHandler:      UnhandledExceptionHandler
        ,mlText:         MLText
        ,loadingCtrl:    LoadingController
        ,sanitizer:      DomSanitizer
        ,appDataBroker:  AppDataBroker
    ) {
        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content:             pMessage
                ,dismissOnPageChange: true
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.BackToSignIn = () => { this.nav.setRoot(SignInPage);  };

        this.GoToWelcome = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaWelcome'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(WelcomePage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaWelcome' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(WelcomePage);
                
                    return;
                });
            });
        };

        this.GoToTemplate = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaTemplate'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(TemplatePage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaTemplate' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(TemplatePage);
                
                    return;
                });
            });
        };

        this.GoToHousekeeping  = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaHousekeeping'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(HousekeepingPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaHousekeeping' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(HousekeepingPage);
                
                    return;
                });
            });
        };

        this.GoToDetails = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaDetails'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(DetailsPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaDetails' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(DetailsPage);
                
                    return;
                });
            });
        };

        this.GoToEnable = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaEnable'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(EnablePage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaEnable' ,() => {
                    loading.Dismiss();
                
                    this.nav.setRoot(EnablePage);
                
                    return;
                });
            });
        };

        this.GoToDiscounts = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaDiscounts'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(DiscountsPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaDiscounts' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(DiscountsPage);
                
                    return;
                });
            });
        };

        this.GoToDiscountCal = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaDiscountCal'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(DiscountCalPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaDiscountCal' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(DiscountCalPage);
                
                    return;
                });
            });
        };

        this.GoToRoomTypes = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaRoomTypes'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(RoomTypesPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaRoomTypes' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(RoomTypesPage);
                
                    return;
                });
            });
        };

        this.GoToAvailability = () => {
            if (
                mlText.IsViewLangLoaded(
                    'HotelAreaAvailability'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(AvailabilityPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark', 'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID(), 'HotelAreaAvailability', () => {
                    loading.Dismiss();

                    this.nav.setRoot(AvailabilityPage);

                    return;
                });
            });
        };

        this.GoToOfferTypes = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaOfferTypes'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(OfferTypesPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaOfferTypes' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(OfferTypesPage);
                
                    return;
                });
            });
        };

        this.GoToCustomPackages = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaDerivedPackages'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(CustomPackagesPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaDerivedPackages' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(CustomPackagesPage);
                
                    return;
                });
            });
        }; 

        this.GoToEarlyBird = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaEarlyBird'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(EarlyBirdPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaEarlyBird' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(EarlyBirdPage);
                
                    return;
                });
            });
        };

        this.GoToChannel = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaChannel'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(ChannelPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaChannel' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(ChannelPage);
                
                    return;
                });
            });
        };

        this.GoToRates = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaRates'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(RatesPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'HotelAreaRates' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(RatesPage);
                
                    return;
                });
            });
        };

        this.GoToRooms = () => {
            if (
                mlText.IsViewLangLoaded(
                     'CTMExtranetRooms'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(RoomsPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'CTMExtranetRooms' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(RoomsPage);
                
                    return;
                });
            });
        };

        this.GoToTaskList = () => {
            if (
                mlText.IsViewLangLoaded(
                     'CTMExtranetTaskList'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(TaskListPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'CTMExtranetTaskList' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(TaskListPage);
                
                    return;
                });
            });
        };

        this.GoToTaskReport = () => {
            if (
                mlText.IsViewLangLoaded(
                     'CTMExtranetTaskReport'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(TaskReportPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID() ,'CTMExtranetTaskReport' ,() => {
                    loading.Dismiss();
                    
                    this.nav.setRoot(TaskReportPage);
                
                    return;
                });
            });
        };

        this.GoToStaff = () => {
            if (
                mlText.IsViewLangLoaded(
                     'CTMExtranetStaff'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(StaffPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID(), 'CTMExtranetStaff', () => {
                    loading.Dismiss();

                    this.nav.setRoot(StaffPage);
                
                    return;
                });
            });
        };

        this.GoToDescriptions = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaDescriptions'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(DescriptionsPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID(), 'HotelAreaDescriptions', () => {
                    loading.Dismiss();

                    this.nav.setRoot(DescriptionsPage);

                    return;
                });
            });
        };

        this.GoToPhotos = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaPhotos'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(PhotosPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID(), 'HotelAreaPhotos', () => {
                    loading.Dismiss();

                    this.nav.setRoot(PhotosPage);

                    return;
                });
            });
        };

        this.GoToDocs = () => {
            if (
                mlText.IsViewLangLoaded(
                    'HotelAreaBrochures'
                    , mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(DocsPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark', 'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID(), 'HotelAreaBrochures', () => {
                    loading.Dismiss();

                    this.nav.setRoot(DocsPage);

                    return;
                });
            });
        };

        this.GoToMaps = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaMaps'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(MapsPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID(), 'HotelAreaMaps', () => {
                    loading.Dismiss();

                    this.nav.setRoot(MapsPage);

                    return;
                });
            });
        };

        this.GoToFacilities = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaFacilities'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(FacilitiesPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            loading.Show(() => {
                mlText.LoadView(mlText.GetLangID(), 'HotelAreaFacilities', () => {
                    loading.Dismiss();

                    this.nav.setRoot(FacilitiesPage);

                    return;
                });
            });
        };

        this.GoToCancellation = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaCancellation'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(CancellationPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            mlText.LoadView(mlText.GetLangID() ,'HotelAreaCancellation' ,() => {
                loading.Dismiss();
                
                this.nav.setRoot(CancellationPage);

                return;
            });
        };

        this.GoToBookings = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaBookings'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(BookingsPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            mlText.LoadView(mlText.GetLangID() ,'HotelAreaBookings' ,() => {
                loading.Dismiss();
                
                this.nav.setRoot(BookingsPage);

                return;
            });
        };

        this.GoToChangePassword = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaChangePassword'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(ChangePasswordPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            mlText.LoadView(mlText.GetLangID() ,'HotelAreaChangePassword' ,() => {
                loading.Dismiss();
                
                this.nav.setRoot(ChangePasswordPage);

                return;
            });
        };

        this.GoToPayment = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaPayment'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(PaymentPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            mlText.LoadView(mlText.GetLangID() ,'HotelAreaPayment' ,() => {
                loading.Dismiss();
                
                this.nav.setRoot(PaymentPage);

                return;
            });
        };

        this.GoToSpotlight = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaSpotlight'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(SpotlightPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            mlText.LoadView(mlText.GetLangID() ,'HotelAreaSpotlight' ,() => {
                loading.Dismiss();
                
                this.nav.setRoot(SpotlightPage);

                return;
            });
        };

        this.GoToPMS = () => {
            if (
                mlText.IsViewLangLoaded(
                     'HotelAreaPMS'
                    ,mlText.GetLangID()
                )
            ) {
                this.nav.setRoot(PMSPage);

                return;
            }

            let app = mlText.GetBroker('BookingEngineAppTexts');

            let loading: dmLoading = this.NewLoading(
                app.Text('LoadingMark' ,'Loading...')
            );

            mlText.LoadView(mlText.GetLangID() ,'HotelAreaPMS' ,() => {
                loading.Dismiss();
                
                this.nav.setRoot(PMSPage);

                return;
            });
        };

        this.MarkURISafe = (pURI: string) => {
            return sanitizer.bypassSecurityTrustUrl(pURI);
        };

        let langID:           number = 1;
        let hotelID:          number = 1;
        let isSessionExpired: number = 0;

        /* external params are guaranteed sane if present via server-side C# */
        let params = new URLSearchParams(window.location.search.substr(1));

        let paramLangID             = params.get('LangID');
        let paramHotelID            = params.get('HotelID');
        let paramIsSessionExpired   = params.get('IsSessionExpired');

        let hotel: dmHotel = new dmHotel(
             mlText.GetLangID()
            ,this.MarkURISafe
        );

        if (paramHotelID) {
            hotel.IsWebContext      = true;
            hotel.ChainWantsHotelID = Number(paramHotelID);
        } else {
            hotelID                 = 0;
        }

        if (paramLangID) {
            hotel.IsWebContext      = true;
            langID                  = Number(paramLangID);
        } else {
            langID                  = 1;
        }

        if (paramIsSessionExpired) {
            isSessionExpired        = Number(paramIsSessionExpired);
        } else {
            isSessionExpired        = 0;
        }

        if (isSessionExpired > 0) {
            hotel.IsSessionExpired  = true;
        }

        this.AppMenu = new AppMenuViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.GoToWelcome
            ,this.GoToTemplate
            ,this.GoToHousekeeping
            ,this.GoToDetails
            ,this.GoToEnable
            ,this.GoToDiscounts
            ,this.GoToDiscountCal
            ,this.GoToRoomTypes
            ,this.GoToAvailability
            ,this.GoToOfferTypes
            ,this.GoToCustomPackages
            ,this.GoToEarlyBird
            ,this.GoToChannel
            ,this.GoToRates
            ,this.GoToRooms
            ,this.GoToTaskList
            ,this.GoToTaskReport
            ,this.GoToStaff
            ,this.GoToDescriptions
            ,this.GoToPhotos
            ,this.GoToDocs
            ,this.GoToMaps
            ,this.GoToFacilities
            ,this.GoToCancellation
            ,this.GoToBookings
            ,this.GoToChangePassword
            ,this.GoToPayment
            ,this.GoToSpotlight
            ,this.GoToPMS
        );

        console.log('set app data');

        appDataBroker.SetAppData(hotel);
        appDataBroker.SetAppMenuViewModel(this.AppMenu);

        platform.ready().then((readySource) => {
            exHandler.InitialiseNav(
                 this.nav
                ,applicationRef
                ,application
                ,LoadingPage
                ,(pIsException: boolean, pIsNetworkOrSession: boolean) => {
                    if (pIsException) {
                        this.AppMenu.HasException    = true;
                    }

                    if (pIsNetworkOrSession) {
                        this.AppMenu.HasNetworkError = true;
                    }

                    applicationRef.tick();
                }
                ,() => {
                    hotel.IsAuthenticated = false;

                    RQApp.SetSession('NO_API_KEY', '');

                    window.location.href =
                        'https://www.tobook.com/HotelArea/index.html?LangID='
                      + langID
                      + '&HotelID='
                      + hotelID
                      + '&IsSessionExpired=1';
                }
            );

            if (!exHandler.ExceptionsThrown) {
                this.rootPage = LoadingPage;
            }

            if (readySource == 'cordova') {
                statusBar.styleDefault();
                splashScreen.hide();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts